import type { ComponentType, SVGProps } from 'react';
import {
  AirVent,
  Baby,
  Beef,
  Beer,
  Briefcase,
  Building2,
  Cake,
  Car,
  ChefHat,
  Coffee,
  Cog,
  Droplets,
  Dumbbell,
  Egg,
  Fish,
  Flame,
  Flower,
  Fuel,
  GraduationCap,
  Hammer,
  Leaf,
  Lightbulb,
  Milk,
  Monitor,
  Pill,
  Pizza,
  Printer,
  Refrigerator,
  Scissors,
  Server,
  Shirt,
  Snowflake,
  SprayCan,
  Sprout,
  Stethoscope,
  Sun,
  Thermometer,
  Tractor,
  Droplet,
  UtensilsCrossed,
  WashingMachine,
  Wheat,
  Wind,
  Wine,
  Wrench,
  Zap,
} from 'lucide-react';
import type { UsageIconKey } from '@shared/constants/naf-usages';

type IconComponent = ComponentType<SVGProps<SVGSVGElement> & { size?: number | string }>;

export const USAGE_ICONS: Record<UsageIconKey, IconComponent> = {
  flame: Flame,
  zap: Zap,
  fire: Flame,
  sun: Sun,
  snowflake: Snowflake,
  thermometer: Thermometer,
  refrigerator: Refrigerator,
  'chef-hat': ChefHat,
  utensils: UtensilsCrossed,
  lightbulb: Lightbulb,
  droplet: Droplet,
  wind: Wind,
  wrench: Wrench,
  cog: Cog,
  printer: Printer,
  scissors: Scissors,
  shirt: Shirt,
  'washing-machine': WashingMachine,
  car: Car,
  fuel: Fuel,
  'spray-can': SprayCan,
  monitor: Monitor,
  server: Server,
  briefcase: Briefcase,
  cup: Coffee,
  pizza: Pizza,
  cake: Cake,
  leaf: Leaf,
  tractor: Tractor,
  wheat: Wheat,
  sprout: Sprout,
  milk: Milk,
  egg: Egg,
  fish: Fish,
  beef: Beef,
  wine: Wine,
  beer: Beer,
  flower: Flower,
  pill: Pill,
  stethoscope: Stethoscope,
  baby: Baby,
  'graduation-cap': GraduationCap,
  dumbbell: Dumbbell,
  hammer: Hammer,
  pump: Droplets,
  'air-vent': AirVent,
  building: Building2,
};

export function getUsageIcon(key: UsageIconKey): IconComponent {
  return USAGE_ICONS[key] ?? Briefcase;
}
